export const ERROR = 'error';
export const ERROR_CHAT = 'errorChat';
export const SUCCESS = 'success';
export const WARNING = 'warning';
export const WARNING_PONR = 'warningPonr';
export const WARNING_PONR_ALT = 'warningPonrAlt';
export const WARNING_HIGH_DEMAND = 'warningHighDemand';

export const ICON_COLOR = {
  [ERROR]: '#FFFFFF',
  [ERROR_CHAT]: '#FFFFFF',
  [SUCCESS]: '#FFFFFF',
  [WARNING]: '#2A2A2A',
  [WARNING_PONR]: '#2A2A2A',
  [WARNING_PONR_ALT]: '#2A2A2A',
  [WARNING_HIGH_DEMAND]: '#2A2A2A',
};

export const NOTIFICATION_CONTENT = {
  [WARNING]: {
    title: 'Amendment not available',
    message: 'Please try again later, if this issue persists, please reach out to us via live chat.',
    analytics: ':amend appt model',
  },
  [WARNING_PONR]: {
    title: 'You can make changes up to 12noon today',
    message: 'As your appointment’s approaching fast, you only have a short time to change it. Don’t miss out.',
    analytics: ':amend appt model',
  },
  [WARNING_PONR_ALT]: {
    title: 'You can make changes up to 12noon today',
    message: 'As your appointment’s approaching fast, you only have a short time to change it. Don’t miss out.',
    analytics: ':amend appt confirmation model',
  },
  [WARNING_HIGH_DEMAND]: {
    title: 'High demand for engineer visits',
    message:
      'Openreach has given you their earliest available engineer visit for your order requirements. We won’t be able to offer you an earlier one. Thank you for your patience.',
    analytics: ':Order summary',
  },
  [ERROR]: {
    title: 'An error occurred',
    message: "Due to an issue on our side, we haven't been able to save your changes. Please try again.",
    analytics: ':amend appt confirmation model',
  },
  [ERROR_CHAT]: {
    title: 'An error occurred',
    message:
      'Due to an issue on our side, we are not able to amend your appointment. Please try again later, or if you need to amend it right away, chat with us now.',
    analytics: ':amend appt model',
  },
  [SUCCESS]: {
    title: 'Thank you for your information',
    message: `Once we receive confirmation from our supplier, we’ll update the order status.`,
    analytics: ':Order summary',
  },
};

export const LIST_OF_TYPES_WITH_CHAT_BUTTON = [
  ERROR_CHAT,
  WARNING,
  WARNING_PONR,
  WARNING_PONR_ALT,
];
